import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import { SOMETHING_WENT_WRONG, TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS } from "../services/constants";
import { defaultListOfStatusAvailableUrl } from "../services/dataManager";
import { EXPORT_TYPE, exportPdf } from "../services/fileDownload";
import { showToastNotification } from "./toast";
import { setIssuesCount } from "../reducers/issuesCount";
import { setTasksStatusesData } from "../reducers/tasksStatuses";
import { setFilesStatusesData } from "../reducers/filesStatuses";
import { setZoomLevel as setZoomLevelAction } from "../reducers/zoomSlice";
import { setExtraIssuesData as setExtraIssueAction } from "../reducers/extraIssue";
import { setIssuesStatusesData as setIssuesStatusesDataAction } from "../reducers/issuesStatuses";
import { setEstimatesStatusesData as setEstimatesStatusesDataAction } from "../reducers/estimateStatuses";
import { setProjectsStatusesData as setProjectsStatusesDataAction } from "../reducers/projectsStatuses";
import { setEditIssuesData as setEditIssuesDataAction } from "../reducers/editIssues";
import { setItemsHaveError, setItemsAreLoading } from "../reducers/bcfData";
import {
  setIssuesPinData as setIssuesPinDataAction,
  mergeIssuesPinData as mergeIssuesPinDataAction,
} from "../reducers/issuesPinDataSlice";
import {
  updateIssuesData as arrangeIssuesData,
  setIssuesData,
  modifyIssuesData,
  setIssuesCommentsData,
  deleteIssuesCommentsData,
  mergeIssuesData,
  removeIssueFromState,
} from "../reducers/issues";
export const itemsHaveError = (bool) => setItemsHaveError(bool);
export const itemsAreLoading = (bool) => setItemsAreLoading(bool);
export const setIssuesPinData = setIssuesPinDataAction;
export const setExtraIssueData = setExtraIssueAction;
import i18n from "@i18n";

const { t } = i18n;

export function removeIssueFromForm(ids, formId) {
  return async (dispatch) => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/issues/removeIssueFromForm`, {
      ids,
      formId,
    });
    if (response.data.status) {
      dispatch(removeIssueFromState({ ids }));
      dispatch(
        showToastNotification({
          content: t("All the selected Issue(s) were removed"),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
    } else {
      dispatch(
        showToastNotification({
          content: SOMETHING_WENT_WRONG,
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
    return response.data.status;
  };
}
export function addFormIdToIssues(ids, formId) {
  return async (dispatch) => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/issues/addFormIdToIssues`, {
      ids,
      formId,
    });
    if (response.data.status) {
      dispatch(
        showToastNotification({
          content: t("All the selected Issue(s) were added"),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
    } else {
      dispatch(
        showToastNotification({
          content: SOMETHING_WENT_WRONG,
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
  };
}
export const mergeIssuesPinData = mergeIssuesPinDataAction;
export const setIssuesStatusesData = setIssuesStatusesDataAction;
export const setEstimatesStatusesData = setEstimatesStatusesDataAction;
export { setFilesStatusesData };
export { setIssuesCount } from "../reducers/issuesCount";
export { setTasksStatusesData } from "../reducers/tasksStatuses";
export const setProjectsStatusesData = setProjectsStatusesDataAction;
export function updateTaskData(data) {
  return {
    type: "UPDATE_TASK_DATA",
    data,
  };
}
export function removeTaskData(data) {
  return {
    type: "REMOVE_TASK_DATA",
    data,
  };
}
export function getCommentsData(data) {
  return async (dispatch) => {
    dispatch(itemsAreLoading(true));
    const responseData = await axiosWrapper.post(`${getBackendUrl()}/comments/getCommentsData`, data);
    if (responseData.data.status) {
      dispatch(setIssuesCommentsData({ data: responseData.data.data, issueId: data.issueId }));
      return responseData.data.data;
    }
  };
}
export function saveCommentsData(data) {
  return (dispatch) => {
    dispatch(itemsAreLoading(true));
    axiosWrapper
      .post(`${getBackendUrl()}/comments/saveCommentsData`, data)
      .then((response) => {
        if (response.data.status) {
          dispatch(
            setIssuesCommentsData({ data: response.data.data, issueId: data.issueId, isEdit: !!data.commentId }),
          );
        }
      })
      .catch(() => dispatch(itemsHaveError(true)));
  };
}
export function deleteCommentsData(data) {
  return (dispatch) => {
    dispatch(itemsAreLoading(true));
    axiosWrapper
      .post(`${getBackendUrl()}/comments/deleteCommentsData`, data)
      .then((response) => {
        if (response.data.status) {
          dispatch(deleteIssuesCommentsData({ commentId: data.commentId, issueId: data.issueId }));
        }
      })
      .catch(() => dispatch(itemsHaveError(true)));
  };
}
export const issuesInFilesCount = async (data) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/issues/getIssuesData`, data);
  return response.data.result.length;
};
export function saveIssuesData(data, id, toast = true) {
  return async (dispatch) => {
    dispatch(itemsAreLoading(true));
    const response = await axiosWrapper.post(`${getBackendUrl()}/issues/saveIssuesData`, data);
    if (response.data.status) {
      dispatch(mergeIssuesData({ data: response.data.data, editId: id }));
      dispatch(
        mergeIssuesPinData({
          id: response.data.data.id,
          pinData: response.data.data.pinData,
        }),
      );
      const toastContent = id ? "Issue has been edited successfully!" : "Issue has been created successfully!";
      if (toast) {
        dispatch(
          showToastNotification({
            content: toastContent,
            type: TOAST_TYPE_SUCCESS,
          }),
        );
      }
    } else {
      dispatch(
        showToastNotification({
          content: SOMETHING_WENT_WRONG,
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
    return response.data.status;
  };
}
export function getIssuesData(data, returnValue = false) {
  return async (dispatch) => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/issues/getIssuesData`, data);
    if (response.data.status) {
      dispatch(setIssuesData(response.data.result));
      if (response.data.count) {
        dispatch(setIssuesCount(response.data.count));
      }
    }
    if (returnValue) {
      return response.data.result;
    }
  };
}

export async function getIssuesList(data) {
  const response = await axiosWrapper.post(`${getBackendUrl()}/issues/getIssuesData`, data);
  return response.data.result;
}
export function getIssueViewpointData(data) {
  return async (dispatch) => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/issues/getIssueViewpointData`, data);
    if (response.data.status) {
      dispatch(modifyIssuesData(response.data.result));
    }
  };
}
export function getfilteredIssuesData(data, returnValue = false) {
  return async (dispatch) => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/issues/getIssuesData`, data);
    if (response.data.status) {
      dispatch(arrangeIssuesData(response.data.result));
    }
    if (returnValue) {
      return response.data.result;
    }
  };
}
export function getIssuesPinData(data) {
  return async (dispatch) => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/issues/getIssuesPinData`, data);
    if (response.data.status) {
      dispatch(setIssuesPinData(response.data.result));
    }
  };
}
// TODO: This function is not used anywhere and backend is also removed
export function getFileData(data, returnValue = false) {
  return async () => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/fileOperations/getFileData`, data);
    if (returnValue) {
      return response.data.data;
    }
  };
}
export function getIssuesDataByPortal(data) {
  return (dispatch) => {
    dispatch(itemsAreLoading(true));
    axiosWrapper
      .post(`${getBackendUrl()}/issues/getIssuesDataByPortal`, data)
      .then((response) => {
        dispatch(setIssuesData(response.data.result));
      })
      .catch(() => dispatch(itemsHaveError(true)));
  };
}
export async function getCompleteIssuesDataByPortal(data) {
  const response = await axiosWrapper.post(`${getBackendUrl()}/issues/getIssuesDataByPortal`, data);
  return response.data.result;
}
export function getTasksStatusesData() {
  return (dispatch) => {
    dispatch(itemsAreLoading(true));
    axiosWrapper
      .get(`${getBackendUrl()}/tasks/getAllStatusesForTasks`)
      .then((response) => {
        if (response.data.status) {
          dispatch(setTasksStatusesData(response.data.data));
        }
      })
      .catch(() => dispatch(itemsHaveError(true)));
  };
}
export function getFilesStatusesData() {
  return (dispatch) => {
    dispatch(itemsAreLoading(true));
    axiosWrapper
      .get(`${getBackendUrl()}/fileUpload/getAllStatusesForFiles`)
      .then((response) => {
        if (response.data.status) {
          dispatch(setFilesStatusesData(response.data.data));
        }
      })
      .catch(() => dispatch(itemsHaveError(true)));
  };
}
export function getProjectsStatusesData() {
  return (dispatch) => {
    dispatch(itemsAreLoading(true));
    axiosWrapper
      .get(`${getBackendUrl()}/projects/getAllStatusesForProjects`)
      .then((response) => {
        if (response.data.status) {
          dispatch(setProjectsStatusesData(response.data.data));
        }
      })
      .catch(() => dispatch(itemsHaveError(true)));
  };
}
export function saveProjectStatus(data) {
  return (dispatch) => {
    axiosWrapper
      .post(`${getBackendUrl()}/projects/saveProjectStatus`, data)
      .then((response) => {
        if (response.data.status) {
          dispatch(
            showToastNotification({
              content: t("Status changed successfully"),
            }),
          );
        }
      })
      .catch(() => dispatch(itemsHaveError(true)));
  };
}
export function saveProjectAttachedPositionData(data) {
  return async (dispatch) => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/projects/saveProjectAssignedPosition`, data);
    let toastFields;
    if (response.data.status) {
      toastFields = {
        content: "Assigned position changed successfully",
        type: TOAST_TYPE_SUCCESS,
      };
    } else {
      toastFields = {
        content: response.data.errorMessage,
        type: TOAST_TYPE_ERROR,
      };
    }
    dispatch(showToastNotification(toastFields));
  };
}
export function saveTaskStatus(data) {
  return async (dispatch) => {
    await axiosWrapper
      .post(`${getBackendUrl()}/tasks/saveTaskStatus`, data)
      .then((response) => {
        if (response.data.status) {
          dispatch(updateTaskData(data));
        }
      })
      .catch(() => dispatch(itemsHaveError(true)));
  };
}
export async function deleteTask(data) {
  const response = await axiosWrapper.post(`${getBackendUrl()}/tasks/deleteTask`, data);
  return response;
}
export async function saveProjectData(data) {
  const response = await axiosWrapper.post(`${getBackendUrl()}/projects/saveProjectsData`, data);
  return response.data;
}
export const setZoomLevel = setZoomLevelAction;
export const setEditIssuesData = setEditIssuesDataAction;
export async function getPdfMarkUpData(data) {
  const response = await axiosWrapper.post(`${getBackendUrl()}/issues/getPdfMarkUpData`, data);
  return response;
}
export function successReadNotificationToast(selectedNotificationsId) {
  return async (dispatch) => {
    dispatch(
      showToastNotification({
        content: `Notification${selectedNotificationsId.length > 1 ? "s" : ""} successfully marked as read`,
        type: TOAST_TYPE_SUCCESS,
      }),
    );
  };
}
export async function getCommentsList(data) {
  return await axiosWrapper.post(`${getBackendUrl()}/comments/getCommentsData`, data);
}
async function getIssuesIdToExport(data) {
  return await axiosWrapper.post(`${getBackendUrl()}/issues/getIssuesIdToExport`, data);
}
export async function handleIssuesExportAsPDF({ projectId, issuesIds }) {
  if (!issuesIds) {
    const res = await getIssuesIdToExport({ projectId });
    if (res.data.status) {
      issuesIds = res.data.result;
    } else {
      return res.data;
    }
  }
  if (issuesIds.length) {
    exportPdf({ issuesIds, exportType: EXPORT_TYPE.PDF });
  } else {
    return {
      status: false,
      errorMessage: "There are no issues in this Project",
    };
  }
}
export const issuesBcfImport = async (data) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/issues/saveIssuesDataFromBCF`, data);
  return response;
};
export const getDefaultListOfStatusAvailable = async ({ spaceId, entityType }) => {
  const data = {
    value: {
      params: {
        entityType,
        spaceId,
      },
      entityType,
      spaceId,
    },
  };
  return await axiosWrapper.post(defaultListOfStatusAvailableUrl, data);
};
